import moment from 'moment';
import React, { useState } from 'react';
import AnimateHeight from 'react-animate-height';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import EntityModification from 'src/models/entityModificationLogs/EntityModification';

interface IEntityChangeLog {
    changeLogs: Array<EntityModification>;
    omitKeys: Array<string>;
    legendTitle: string;
    keyPrefix: string;
}

const EntityChangeLog = (props: IEntityChangeLog) => {
    const [displayLog, setDisplayLog] = useState<string | number>(0);
    const [currentLog, setCurrentLog] = useState<number>(0);

    const incrementLog = (isNext: boolean) => {
        let i = isNext ? 1 : -1;
        setCurrentLog(currentLog + i);
    };

    // TODO: Add ModificationLogEntities param if unique omitKeys are needed for a given entity.
    const displayProperties = (isOriginal: boolean) => {
        let logBody: unknown;

        if (isOriginal) {
            logBody = JSON.parse(props.changeLogs[currentLog].originalEntity);
        } else {
            logBody = JSON.parse(props.changeLogs[currentLog].changedEntity);
        }

        // Note: These props are in Pascal case for some reason.
        let entityProps = Object.entries(logBody).filter(bp => !props.omitKeys.includes(bp[0]));

        return (
            <div style={{ width: '40%' }} >
                {entityProps.map(bp => {
                    let bpValue = bp[1];
                    if (!bpValue || typeof bpValue === 'object') {
                        bpValue = '(Empty)';
                    } else if (Object.prototype.toString.call(bpValue) === '[object Date]') {
                        bpValue = moment(bp[1]).format('YYYY-MM-DD').toString();
                    }
                    return <div key={`Original ${props.keyPrefix}-` + bp[0]}>{bp[0]} - {bpValue}</div>;
                })}
            </div>
        );
    };    

    return (
        <>
            <div
                style={{ cursor: 'pointer' }}
                onClick={() =>
                    setDisplayLog(displayLog === 'auto' ? 0 : 'auto' )
                }
            >
                <RHFLegend title={props.legendTitle} />
            </div>
            <AnimateHeight
                duration={500}
                height={displayLog}
                children={
                    <>
                        <div>
                            Modification Date: {moment(props.changeLogs[currentLog]?.modifiedDate).format('YYYY-MM-DD').toString()}
                        </div>
                        {props.changeLogs?.length > 0 && (
                            <div>
                                <div>
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '24%', height: '3rem', marginLeft: '.5rem' }}
                                        text={'Previous'}
                                        onClick={() => incrementLog(false)}
                                        disabled={currentLog === 0}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '24%', height: '3rem', marginLeft: '.5rem' }}
                                        text={'Next'}
                                        onClick={() => incrementLog(true)}
                                        disabled={currentLog === props.changeLogs.length - 1}
                                    />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    {displayProperties(true)}
                                    {displayProperties(false)}
                                </div>
                            </div>
                        )}
                    </>
                }
            />
        </>
    );
};

export default EntityChangeLog;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/EntityModificationComponents/EntityChangeLog.tsx